/* Best-Preis: sort the rendered product grid by discount.
 *
 * Reads the figures product-card.liquid already put on each card, so no formatted
 * price is ever parsed out of the DOM. Ordering is applied with CSS `order`, which
 * also carries the standing rule: photoless items sink below everything, sold-out
 * items below those, whatever the sort.
 *
 * Shopify paginates server-side, so this orders the current page only. The control
 * says so, and hides entirely when nothing on the page is discounted.
 */
(function () {
  var PARAM = 'bp_sort';
  var SINK_PHOTOLESS = 10000;
  var SINK_SOLD = 20000;

  function grids() {
    return document.querySelectorAll('.product-grid, .resource-list');
  }

  function itemsOf(grid) {
    var out = [];
    for (var i = 0; i < grid.children.length; i++) {
      var el = grid.children[i];
      if (el.matches && el.matches('.product-grid__item, .resource-list__item')) out.push(el);
    }
    return out;
  }

  function read(el) {
    var card = el.querySelector('product-card');
    return {
      el: el,
      off: Number((card && card.dataset.bpOff) || 0),
      save: Number((card && card.dataset.bpSave) || 0),
      photoless: !!el.querySelector('.product-card-gallery__title-placeholder'),
      sold: !!(card && card.hasAttribute('data-bp-sold')),
    };
  }

  function apply(mode) {
    var anyDiscount = false;

    grids().forEach(function (grid) {
      var rows = itemsOf(grid).map(read);
      if (!rows.length) return;

      rows.forEach(function (r) {
        if (r.off > 0) anyDiscount = true;
      });

      if (!mode) {
        // Hand ordering back to the stylesheet's standing rule.
        rows.forEach(function (r) {
          r.el.style.order = '';
        });
        return;
      }

      var ranked = rows.slice().sort(function (a, b) {
        return mode === 'pct' ? b.off - a.off : b.save - a.save;
      });

      ranked.forEach(function (r, i) {
        var order = i;
        if (r.photoless) order += SINK_PHOTOLESS;
        if (r.sold) order += SINK_SOLD;
        r.el.style.order = String(order);
      });
    });

    return anyDiscount;
  }

  function setActive(bar, mode) {
    bar.querySelectorAll('.bp-sort__btn').forEach(function (b) {
      b.classList.toggle('is-active', (b.dataset.bpSortMode || '') === (mode || ''));
    });
    var note = bar.querySelector('[data-bp-sort-note]');
    if (note) note.hidden = !mode;
  }

  function currentMode() {
    try {
      var m = new URL(window.location.href).searchParams.get(PARAM);
      return m === 'pct' || m === 'amount' ? m : '';
    } catch (e) {
      return '';
    }
  }

  function run() {
    var bar = document.querySelector('[data-bp-sort]');
    var mode = currentMode();
    var anyDiscount = apply(mode);
    if (!bar) return;
    bar.hidden = !anyDiscount;
    setActive(bar, mode);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bp-sort__btn');
    if (!btn) return;
    var mode = btn.dataset.bpSortMode || '';
    try {
      var url = new URL(window.location.href);
      if (mode) url.searchParams.set(PARAM, mode);
      else url.searchParams.delete(PARAM);
      history.replaceState({}, '', url);
    } catch (err) {
      /* URL not writable; sorting still applies for this view */
    }
    apply(mode);
    var bar = btn.closest('[data-bp-sort]');
    if (bar) setActive(bar, mode);
  });

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      run();
    });
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Horizon morphs the grid on filter and pagination; re-apply to whatever arrives.
  new MutationObserver(schedule).observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
